import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

import { AppService } from './app.service';
import { LocaleService } from './locale/locale.service';
import { AllowedLangsEnum } from './locale/locale.enum';
import { LOCALE_ROUTES_CONFIG } from './locale/locale-routes.config';

@Injectable()
export class I18nUrlSerializer implements UrlSerializer {
  private defaultUrlSerializer = new DefaultUrlSerializer();
  private isExplicitDefault = true;

  constructor(private app: AppService, private locale: LocaleService) {
    const serializer = this;
    UrlTree.prototype.toString = function () {
      return serializer.serialize(this);
    };
  }

  parse(url: string): UrlTree {
    const query = (url.match(/\?.*/g) || [])[0] || '';
    url = url.replace(query, '');
    const pureUrl = clearSegmentsFromUrl(url);
    return this.defaultUrlSerializer.parse(`${pureUrl}${query}`);
  }

  serialize(tree: UrlTree): string {
    const url = decodeURI(this.defaultUrlSerializer.serialize(tree));
    // LOCK at for now
    let code = this.locale.appLocale || '';
    let language = this.app.currentLangIso as AllowedLangsEnum;
    if (!this.isExplicitDefault && language === 'en') {
      language = '' as AllowedLangsEnum;
    }
    return `${code}/${language}${url}`.replace('//', '/').replace('//', '/');
  }
}

export function clearSegmentsFromUrl(url: string) {
  const locale = (getSegmentFromUrl(`${url}/`, 'region') || '').toLowerCase();
  const language = (getSegmentFromUrl(`${url}/`, 'lang') || '').toLowerCase();
  return url.replace(locale, '').replace(language, '').replace('//', '/').replace('//', '/');
}

export function getSegmentFromUrl(url: string, segType: 'region' | 'lang'): string | null {
  const segments = url.split('/').filter(Boolean); // removes empty parts
  const ind = segType === 'lang' ? 1 : 0;
  return segments.length > ind && segments[ind].length === 2 ? segments[ind].toLowerCase() : null;
}

export function translateSegmentsFromEnglish(url: string, lang: AllowedLangsEnum): string {
  const segments = url.split('/').filter(Boolean);
  const translatedSegments = segments.map((segment) => {
    for (const [_, langs] of Object.entries(LOCALE_ROUTES_CONFIG)) {
      const localized = langs[lang];
      const en = langs[AllowedLangsEnum.EN];
      if (localized && segment === en) {
        return localized;
      }
    }
    return segment;
  });
  return '/' + translatedSegments.join('/');
}

export function translateSegmentsToEnglish(url: string, lang: AllowedLangsEnum): string {
  const segments = url.split('/').filter(Boolean);
  const translatedSegments = segments.map((segment) => {
    for (const [_, langs] of Object.entries(LOCALE_ROUTES_CONFIG)) {
      const localized = langs[lang];
      const en = langs[AllowedLangsEnum.EN];
      if (localized && segment === localized) {
        return en;
      }
    }
    return segment;
  });
  return '/' + translatedSegments.join('/');
}
